'use strict';

exports.__esModule = true;

var _StatusPill = require('./StatusPill');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StatusPill).default;
  }
});
Object.defineProperty(exports, 'STATUSPILL_TONES', {
  enumerable: true,
  get: function get() {
    return _StatusPill.STATUSPILL_TONES;
  }
});

var _StatusPillStyled = require('./StatusPillStyled');

Object.defineProperty(exports, 'PillBox', {
  enumerable: true,
  get: function get() {
    return _StatusPillStyled.PillBox;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }